module.exports = __webpack_public_path__ + "img/arrow_left.ce472123.svg";